var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-nav-bar',{attrs:{"title":_vm.docFileName,"fixed":"","left-arrow":_vm.hasLeft},on:{"click-left":_vm.onClickLeft}})
}
var staticRenderFns = []

export { render, staticRenderFns }